/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ level: NonNullable<unknown>, where: NonNullable<unknown> }} Today_Checkin_Ask_WhereInputs */

const en_us2_today_checkin_ask_where = /** @type {(inputs: Today_Checkin_Ask_WhereInputs) => LocalizedString} */ (i) => {
	if (i?.level === "moderate") return /** @type {LocalizedString} */ (`My muscles are moderately sore ${i?.where}. What about today's workout?`);
	return /** @type {LocalizedString} */ (`My muscles are very sore ${i?.where}. What about today's workout?`)
	
};

const pt_br2_today_checkin_ask_where = /** @type {(inputs: Today_Checkin_Ask_WhereInputs) => LocalizedString} */ (i) => {
	if (i?.level === "moderate") return /** @type {LocalizedString} */ (`Estou com dor muscular moderada ${i?.where}. Como fica o treino de hoje?`);
	return /** @type {LocalizedString} */ (`Estou com dor muscular intensa ${i?.where}. Como fica o treino de hoje?`)
	
};

const es_419_today_checkin_ask_where = /** @type {(inputs: Today_Checkin_Ask_WhereInputs) => LocalizedString} */ (i) => {
	if (i?.level === "moderate") return /** @type {LocalizedString} */ (`Tengo dolor muscular moderado ${i?.where}. ¿Qué hago con el entrenamiento de hoy?`);
	return /** @type {LocalizedString} */ (`Tengo dolor muscular intenso ${i?.where}. ¿Qué hago con el entrenamiento de hoy?`)
	
};

const pt_pt2_today_checkin_ask_where = /** @type {(inputs: Today_Checkin_Ask_WhereInputs) => LocalizedString} */ (i) => {
	if (i?.level === "moderate") return /** @type {LocalizedString} */ (`Tenho dor muscular moderada ${i?.where}. Como fica o treino de hoje?`);
	return /** @type {LocalizedString} */ (`Tenho dor muscular intensa ${i?.where}. Como fica o treino de hoje?`)
	
};

const fr_fr2_today_checkin_ask_where = /** @type {(inputs: Today_Checkin_Ask_WhereInputs) => LocalizedString} */ (i) => {
	if (i?.level === "moderate") return /** @type {LocalizedString} */ (`J'ai des courbatures modérées ${i?.where}. Que faire pour la séance d'aujourd'hui ?`);
	return /** @type {LocalizedString} */ (`J'ai de fortes courbatures ${i?.where}. Que faire pour la séance d'aujourd'hui ?`)
	
};

const de_de2_today_checkin_ask_where = /** @type {(inputs: Today_Checkin_Ask_WhereInputs) => LocalizedString} */ (i) => {
	if (i?.level === "moderate") return /** @type {LocalizedString} */ (`Ich habe mittleren Muskelkater ${i?.where}. Was heißt das für das heutige Training?`);
	return /** @type {LocalizedString} */ (`Ich habe starken Muskelkater ${i?.where}. Was heißt das für das heutige Training?`)
	
};

const it_it2_today_checkin_ask_where = /** @type {(inputs: Today_Checkin_Ask_WhereInputs) => LocalizedString} */ (i) => {
	if (i?.level === "moderate") return /** @type {LocalizedString} */ (`Ho un indolenzimento muscolare moderato ${i?.where}. Come faccio con l'allenamento di oggi?`);
	return /** @type {LocalizedString} */ (`Ho un forte indolenzimento muscolare ${i?.where}. Come faccio con l'allenamento di oggi?`)
	
};

/**
* | level | output |
* | --- | --- |
* | "moderate" | "My muscles are moderately sore {where}. What about today's workout?" |
* | * | "My muscles are very sore {where}. What about today's workout?" |
*
* @param {Today_Checkin_Ask_WhereInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_checkin_ask_where = /** @type {((inputs: Today_Checkin_Ask_WhereInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Checkin_Ask_WhereInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_checkin_ask_where(inputs)
	if (locale === "es-419") return es_419_today_checkin_ask_where(inputs)
	if (locale === "pt-PT") return pt_pt2_today_checkin_ask_where(inputs)
	if (locale === "fr-FR") return fr_fr2_today_checkin_ask_where(inputs)
	if (locale === "de-DE") return de_de2_today_checkin_ask_where(inputs)
	if (locale === "it-IT") return it_it2_today_checkin_ask_where(inputs)
	return en_us2_today_checkin_ask_where(inputs)
});
export { today_checkin_ask_where as "today.checkin_ask_where" }